"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStore = exports.getCollection = exports.configureStore = void 0;
var app_1 = __importDefault(require("firebase/app"));
require("firebase/auth");
require("firebase/firestore");
var types_1 = require("./types");
// it's ok even if the apiKey here is leaked, people will still have to have a valid token to actually access data
function firestoreCredentials(environment) {
  if (environment == types_1.Env.PRODUCTION) {
    return {
      projectId: 'data-011419',
      authDomain: 'data-011419.firebaseapp.com',
      apiKey: 'AIzaSyDf6FizXTVq0BgWCcLV_exFg6_WmYRT8Qk'
    };
  } else if (environment == types_1.Env.STAGING) {
    return {
      projectId: 'padlet-staging',
      authDomain: 'padlet-staging.firebaseapp.com',
      apiKey: 'AIzaSyDVS4t6WZpqHnbglX3YM6W3SsWldcgKx-A'
    };
  }
  return {
    projectId: 'development-234618',
    authDomain: 'development-234618.firebaseapp.com',
    apiKey: 'AIzaSyCf_Vju96XTlMSDRbBpnNnwbOQ1KY_JwAw'
  };
}
// Apply our custom firestore settings
function applyFirestoreSettings() {
  app_1.default.firestore().settings({
    cacheSizeBytes: app_1.default.firestore.CACHE_SIZE_UNLIMITED
  });
}
// Authorize firestore
// token is a JWT generated from a service account with permission to access Firestore
// Sample token generation in ruby:
// -------------------------------
// now_seconds = Time.now.to_i
// payload = {
//   iss: service_account_email,
//   sub: service_account_email,
//   aud: "https://identitytoolkit.googleapis.com/google.identity.identitytoolkit.v1.IdentityToolkit".freeze,
//   iat: now_seconds,
//   exp: now_seconds + (60 * 60), # Maximum expiration time is one hour
//   uid: <some_uid>
// }
// openssl_pkey = OpenSSL::PKey::RSA.new private_key
// token = JWT.encode payload, openssl_pkey, "RS256".freeze
// -------------------------------
function authorizeAndConfigFirestore(config) {
  return __awaiter(this, void 0, void 0, function () {
    var credentials;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!app_1.default.apps.length) {
            credentials = void 0;
            if (config.credentials) {
              credentials = config.credentials;
            } else if (config.environment !== null && config.environment !== undefined) {
              // Need to explicitly check !== null and !== undefined because Env.DEVELOPMENT === 0, which is falsey
              credentials = firestoreCredentials(config.environment);
            } else {
              throw new Error('Must provide either `credentials` or `environment`');
            }
            app_1.default.initializeApp(credentials);
          }
          return [4 /*yield*/, app_1.default.auth().signInWithCustomToken(config.token).then(function (userCredential) {
            applyFirestoreSettings();
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
var configurationPromise = null;
function configureStore(config) {
  // Configuration should only happen once.
  // So we cache the configuration promise.
  if (configurationPromise === null) {
    configurationPromise = authorizeAndConfigFirestore(config);
  }
  return configurationPromise;
}
exports.configureStore = configureStore;
function getStore() {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!(configurationPromise === null)) return [3 /*break*/, 1];
          throw new Error('Firestore not configured');
        case 1:
          return [4 /*yield*/, configurationPromise];
        case 2:
          _a.sent();
          _a.label = 3;
        case 3:
          return [2 /*return*/, app_1.default.firestore()];
      }
    });
  });
}
exports.getStore = getStore;
function getCollection(collectionName) {
  return __awaiter(this, void 0, void 0, function () {
    var store;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, getStore()];
        case 1:
          store = _a.sent();
          return [2 /*return*/, store.collection(collectionName)];
      }
    });
  });
}
exports.getCollection = getCollection;